import React from 'react'

import { usePublicToken } from './_load/PublicTokenLoader'
import { useSavePublicToken } from './_requests/savePublicToken'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const formatInitialData = form => ({
  ...form,
  conditions: form.conditions && JSON.stringify(form.conditions || ''),
  payload: form.payload && JSON.stringify(form.payload || '')
})

const EditPublicTokenForm = () => {
  const publicToken = usePublicToken()

  const [onSubmit, { loading, error }] = useSavePublicToken()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={formatInitialData(publicToken || {})}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditPublicTokenForm
